export default __webpack_public_path__ + "static/media/caravan.fa010a1f.svg";